import { render, staticRenderFns } from "./CrudJudgingCriteria.vue?vue&type=template&id=2db1a49e&"
import script from "./CrudJudgingCriteria.vue?vue&type=script&lang=js&"
export * from "./CrudJudgingCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports